export default __webpack_public_path__ + "static/media/butterfly1.88f31ce8.png";